import { useTranslation } from 'react-i18next';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import { IconName } from '@lib/components/Modal/enums';

interface Props {
  searchQuery: string;
  isDefaultPeriod: boolean;
  onClearSearch: () => void;
  onClearPeriod: () => void;
}

/**
 * Three-state empty placeholder for the Top Documents table:
 *   1. Search active        → "No results found" + clear-search action
 *   2. Period filter active → "No results found" + clear-filter action
 *   3. Default period       → "No activity yet" (no action)
 */
export default function TableEmptyState({
  searchQuery,
  isDefaultPeriod,
  onClearSearch,
  onClearPeriod,
}: Props) {
  const { t } = useTranslation();

  if (searchQuery) {
    return (
      <EmptyState
        icon={IconName.SearchOff}
        title={t('no-results-found')}
        text={t('no-results-found-text')}
        actions={[
          <Button
            key="clear"
            buttonText={t('go-back')}
            buttonType={ButtonTypes.primaryFilled}
            leftIcon="arrow_back"
            onClick={onClearSearch}
          />,
        ]}
      />
    );
  }

  if (!isDefaultPeriod) {
    return (
      <EmptyState
        icon={IconName.SearchOff}
        title={t('no-results-found')}
        text={t('no-results-found-text')}
        actions={[
          <Button
            key="clear"
            buttonText={t('clear-filter')}
            buttonType={ButtonTypes.primaryFilled}
            onClick={onClearPeriod}
          />,
        ]}
      />
    );
  }

  return (
    <EmptyState
      icon={IconName.SearchOff}
      title={t('no-activity-yet')}
      text={t('no-activity-yet-text')}
    />
  );
}
